import { createFileRoute } from '@tanstack/react-router';
import { HelpCategoryPage } from '@/pages/help';
import type { HelpCategorySlug } from '@repo/utils';

export const Route = createFileRoute('/protected/_layout/help/$category/')({
  component: HelpCategoryIndexRoute,
});

function HelpCategoryIndexRoute() {
  const { category } = Route.useParams();

  return <HelpCategoryPage category={category as HelpCategorySlug} />;
}
